export default "__VITE_ASSET__LuKvoEno__"